import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconReset = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.7082 5.29165C13.4999 4.08331 11.8416 3.33331 9.99989 3.33331C6.31655 3.33331 3.34155 6.31665 3.34155 9.99998C3.34155 13.6833 6.31655 16.6666 9.99989 16.6666C13.1082 16.6666 15.6999 14.5416 16.4416 11.6666H14.7082C14.0249 13.6083 12.1749 15 9.99989 15C7.24155 15 4.99989 12.7583 4.99989 9.99998C4.99989 7.24165 7.24155 4.99998 9.99989 4.99998C11.3832 4.99998 12.6166 5.57498 13.5166 6.48331L10.8332 9.16665H16.6666V3.33331L14.7082 5.29165Z",
		fill: "#5C5C5C"
	})
});
export default SvgIconReset;
